import { useFormContext } from '@kanda-libs/ks-component-ts';
import { useCallback, useMemo } from 'react';
import {
  FinanceCalculatorFormValues,
  useFinanceCalculatorContext,
} from '../../context';

export interface CalculateMonthlyPaymentsButtonHook {
  onClick: () => void;
  className: string;
  isLoading: boolean;
}

export default function useCalculateMonthlyPaymentsButton(): CalculateMonthlyPaymentsButtonHook {
  const { isLoading, stored, onMonthlyPaymentsClick } =
    useFinanceCalculatorContext();
  const { unregister } = useFormContext<FinanceCalculatorFormValues>();

  const { type } = stored;

  const active = useMemo(() => type === 'monthlyPayments', [type]);

  const className = useMemo(
    () =>
      [
        'px-3 py-2 border rounded-tl-lg text-14-22-em',
        active
          ? 'border-purple-500 bg-purple-50 text-purple-500'
          : 'border-neutral-300 bg-neutral-000 text-neutral-700',
      ].join(' '),
    [active],
  );

  const onClick = useCallback(() => {
    unregister('amountToPayMonthly');
    onMonthlyPaymentsClick();
  }, [unregister, onMonthlyPaymentsClick]);

  return {
    onClick,
    className,
    isLoading,
  };
}
